import { createContext, useContext, useEffect, useState } from "react";
import { login as apiLogin, register as apiRegister, logout as apiLogout, authMe } from "@/lib/afmApi";

const AuthContext = createContext(null);
const STORAGE_KEY = "afm_user";

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const token = localStorage.getItem("sona_session_token");
      if (raw && token) {
        setUser(JSON.parse(raw));
        // Confirmamos que la sesión siga viva (pudo vencer o cerrarse en otro lado).
        authMe(token).catch((e) => {
          if (e?.response?.status === 401) {
            localStorage.removeItem(STORAGE_KEY);
            localStorage.removeItem("sona_session_token");
            setUser(null);
          }
        });
      } else if (raw) {
        localStorage.removeItem(STORAGE_KEY); // sin sesión no hay cuenta que mostrar
      }
    } catch {
      /* noop */
    }
    setLoading(false);
  }, []);

  const persist = (u) => {
    // SEGURIDAD/FIX: el login por correo devuelve la sesión SONA dentro del usuario
    // (session_token). Hay que guardarla donde el cliente la busca para TODAS las
    // llamadas; antes solo el login con Google la guardaba y las demás iban sin sesión.
    try { if (u && u.session_token) localStorage.setItem("sona_session_token", u.session_token); } catch (e) { /* noop */ }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(u));
    setUser(u);
    return u;
  };

  const signIn = async (email, password) => {
    const u = await apiLogin(email, password);
    if (u && u.mfa_required) {
      // Falta el código del correo: guardamos la sesión (bloqueada) y la pantalla del código la libera.
      try {
        localStorage.setItem("sona_session_token", u.session_token);
        sessionStorage.setItem("afm_mfa_hint", u.mfa_email_hint || "");
      } catch (e) { /* noop */ }
      return { mfa: true, hint: u.mfa_email_hint || "" };
    }
    return persist(u);
  };

  const signInWith = (u) => persist(u);

  const signUp = async (payload) => persist(await apiRegister(payload));

  const signOut = async () => {
    await apiLogout();
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem("sona_session_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, signIn, signInWith, signUp, signOut }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
